import {safeText, scrollToHash} from "../../js/util/CommonUtils.js";
import AccessLevel from "../../js/entities/AccessLevel.js";
import {asciidoctorConvertWithOptions} from "../../js/util/AsciiDoctorUtils.js";

export default class PostPageHtml {
	/** @type {HTMLElement} */
	#rootEl;
	#callbacks = {
		onEdit: ()=>{},
		onShare: ()=>{}
	}

	/** @param {Element} rootEl */
	init(rootEl) {
		this.#rootEl = rootEl;
	}

	/** @param {Post} post */
	show(post) {
		this.#rootEl.innerHTML = this.#htmlTemplate(post);
		MathJax.typesetPromise();
		this.#addListeners();
		scrollToHash();
	}

	/** @param {function} cb */
	onEditCb(cb){
		this.#callbacks.onEdit = cb;
	}

	/** @param {function} cb */
	onShareCb(cb){
		this.#callbacks.onShare = cb;
	}

	#onEdit(){
		this.#callbacks.onEdit()
	}

	#onShare(){
		this.#callbacks.onShare()
	}

	#addListeners(){
		const editBtn = this.#getEditButton();
		if (editBtn)
			editBtn.addEventListener('click', this.#onEdit.bind(this))
		const shareBtn = this.#getShareButton();
		if (shareBtn)
			shareBtn.addEventListener('click', this.#onShare.bind(this))
	}

	/** @returns {HTMLElement} */
	#getEditButton(){
		return this.#rootEl.querySelector('[data-action="post-edit"]')
	}

	/** @returns {HTMLElement} */
	#getShareButton(){
		return this.#rootEl.querySelector('[data-action="post-share"]')
	}

	/**
	 * @param {Post} post
	 * @returns {string}
	 */
	#buttonsTemplate(post) {
		const editBtnTemplate = '<button data-action="post-edit" class="button button--text">Edit</button>';
		const shareBtnTemplate = '<button data-action="post-share" class="button button--contained">Share</button>'

		return `
			<div class="post__buttons-block">
				${post.userAccessLevel.meetsOrExceeds(AccessLevel.WRITE) ? editBtnTemplate : ""}
				${post.userAccessLevel.meetsOrExceeds(AccessLevel.ADMIN) ? shareBtnTemplate : ""}
			</div>
		`
	}

	/**
	 * @param {Post} post
	 * @returns {string}
	 */
	#htmlTemplate(post) {
		return `
			<div class="post-page__container">
            	<div class="post">
                	<div class="post__header">
                    	<div class="post__title-block">
					    	<h1 class="post__title js-post-title">${safeText(post.title)}</h1>
					    	<div class="post__data js-post-data">by ${safeText(post.author.displayName)}, last edited: ${post.lastUpdatedDate}</div>
				    	</div>
				    	${this.#buttonsTemplate(post)}
			    	</div>
                	<div class="post__body js-post-body asciidoc-box">${asciidoctorConvertWithOptions(post.body)}</div>
            	</div>
            </div>
        `;
	}
}
